import { defineMessages } from 'react-intl';

export default defineMessages({
  coachMarkTitle: {
    id: 'app.shopDetails.components.Pickup.Toggle.PickupCoachMark.title',
    defaultMessage: 'Pide, retira y disfruta!',
  },
  coachMarkDescription: {
    id: 'app.shopDetails.components.Pickup.Toggle.PickupCoachMark.description',
    defaultMessage:
      'Ahora puedes hacer tu pedido y buscarlo en el restaurante.',
  },
});
